<section class="text-gray-600 body-font">
  <div class="container py-8 mx-auto">
    <div class="flex flex-row justify-evenly flex-wrap gap-4 p-4">
      <div class="group max-w-2xl " simpleGallery [galleryItems]="everydayItems">
        <div class="bg-white shadow-md border border-gray-200 rounded-lg max-w-sm dark:bg-gray-800 dark:border-gray-700 group-hover:shadow-2xl group-hover:opacity-85 duration-300">
            <img class="rounded-t-lg" src="https://acabjj-gallery.s3.eu-central-1.amazonaws.com/everyday/13.jpg" alt="acabjj alltags">
          <div class="p-5">
            <h5 class="text-gray-900 font-bold text-2xl tracking-tight mb-2 dark:text-white">Alltags... (36)</h5>
            <p class="font-normal text-gray-700 mb-3 dark:text-gray-400">Das Dojo. Der Tempel. ACA Brazilian Jiu-Jitsu.</p>
          </div>
        </div>
      </div>
      <div class="group max-w-2xl" simpleGallery [galleryItems]="ajpBern202409Items">
        <div class="bg-white shadow-md border border-gray-200 rounded-lg max-w-sm dark:bg-gray-800 dark:border-gray-700 group-hover:shadow-2xl group-hover:opacity-85 duration-300">
          <img class="rounded-t-lg" src="https://acabjj-gallery.s3.eu-central-1.amazonaws.com/ajpbern202409/1.jpeg" alt="AJP Bern 2024 ACA BJJ">
          <div class="p-5">
            <h5 class="text-gray-900 font-bold text-2xl tracking-tight mb-2 dark:text-white">AJP Bern... (17)</h5>
            <p class="font-normal text-gray-700 mb-3 dark:text-gray-400">4x Gold, 6x Silver, 2x Bronze. 09.2024</p>
          </div>
        </div>
      </div>
      <div class="group max-w-2xl" simpleGallery [galleryItems]="zao202410Items">
        <div class="bg-white shadow-md border border-gray-200 rounded-lg max-w-sm dark:bg-gray-800 dark:border-gray-700 group-hover:shadow-2xl group-hover:opacity-85 duration-300">
          <img class="rounded-t-lg" src="https://acabjj-gallery.s3.eu-central-1.amazonaws.com/zao202410/27.jpeg" alt="Zurich Autumn Open 2024 ACA BJJ">
          <div class="p-5">
            <h5 class="text-gray-900 font-bold text-2xl tracking-tight mb-2 dark:text-white">Zürich Autumn Open... (28)</h5>
            <p class="font-normal text-gray-700 mb-3 dark:text-gray-400">17x Gold, 12x Silver, 7x Bronze. 10.2024</p>
          </div>
        </div>
      </div>
      <div class="group max-w-2xl" simpleGallery [galleryItems]="graduation2024Q4">
        <div class="bg-white shadow-md border border-gray-200 rounded-lg max-w-sm dark:bg-gray-800 dark:border-gray-700 group-hover:shadow-2xl group-hover:opacity-85 duration-300">
          <img class="rounded-t-lg" src="https://acabjj-gallery.s3.eu-central-1.amazonaws.com/graduation2024Q4/2.jpg" alt="ACA BJJ Graduation 2024 Q4">
          <div class="p-5">
            <h5 class="text-gray-900 font-bold text-2xl tracking-tight mb-2 dark:text-white">Graduation 2024 Q4... (25)</h5>
            <p class="font-normal text-gray-700 mb-3 dark:text-gray-400">Zürich, Oerlikon</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="body-font">
  <div class="container px-5 py-12 mx-auto">
    <div class="text-center mb-10">
      <h1 class="text-3xl font-medium title-font text-center mb-8">ACA BJJ Team Dojo</h1>
      <h2 class="text-base text-orange-800 leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
        Bist Du auf der Suche nach einer Herausforderung?
        Dann könnte Brazilian Jiu-Jitsu genau das Richtige für Dich sein!
        In unserem Dojo findest Du eine unterstützende Gemeinschaft,
        in der Du von erfahrenen Trainern lernen und Dich auf neue Fitness- und Fähigkeitsebenen bringen kannst.
        Entdecke, was in Dir steckt und werde Teil unserer BJJ-Familie!
      </h2>
    </div>

    <ngx-simple-gallery [galleryItems]="dojoItems" [galleryConfig]="dojoGalleryConfig"></ngx-simple-gallery>

    <div class="text-orange-900 flex flex-col sm:w-2/3 md:w-1/2 lg:w-1/3 sm:mx-auto sm:mb-2 mt-6">
      <div class="p-2 w-full">
        <div class="rounded flex p-4 h-full items-center">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
               class="w-6 h-6 flex-shrink-0 mr-4" viewBox="0 0 24 24">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
            <path d="M22 4L12 14.01l-3-3"></path>
          </svg>
          <span class="title-font font-medium">120m2 Trainingsfläche</span>
        </div>
      </div>
      <div class="p-2 w-full">
        <div class="rounded flex p-4 h-full items-center">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
               class="w-6 h-6 flex-shrink-0 mr-4" viewBox="0 0 24 24">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
            <path d="M22 4L12 14.01l-3-3"></path>
          </svg>
          <span class="title-font font-medium">Täglich desinfizierte Trainingsmatten</span>
        </div>
      </div>
      <div class="p-2 w-full">
        <div class="rounded flex p-4 h-full items-center">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
               class="w-6 h-6 flex-shrink-0 mr-4" viewBox="0 0 24 24">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
            <path d="M22 4L12 14.01l-3-3"></path>
          </svg>
          <span class="title-font font-medium">Dusche und WC vorhanden</span>
        </div>
      </div>
      <div class="p-2 w-full">
        <div class="rounded flex p-4 h-full items-center">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
               class="w-6 h-6 flex-shrink-0 mr-4" viewBox="0 0 24 24">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
            <path d="M22 4L12 14.01l-3-3"></path>
          </svg>
          <span class="title-font font-medium">getrennte Garderoben</span>
        </div>
      </div>
      <div class="p-2 w-full">
        <div class="rounded flex p-4 h-full items-center">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
               class="w-6 h-6 flex-shrink-0 mr-4" viewBox="0 0 24 24">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
            <path d="M22 4L12 14.01l-3-3"></path>
          </svg>
          <span class="title-font font-medium">Chillout Lounge für Besucher</span>
        </div>
      </div>
      <div class="p-2 w-full">
        <div class="rounded flex p-4 h-full items-center">
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
               class="w-6 h-6 flex-shrink-0 mr-4" viewBox="0 0 24 24">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
            <path d="M22 4L12 14.01l-3-3"></path>
          </svg>
          <span class="title-font font-medium">Rollstuhlgängiger Eingang</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="my-16 sm:mx-4">
  <app-dojo-before-after></app-dojo-before-after>
</section>
